import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ColumnsRow', null, { withChildren: true });
